import { grey } from "@mui/material/colors";

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    flex: 1,
  },
  header: {
    py: 1.5,
    px: 2,
    borderBottom: `1px solid ${grey[300]}`,
  },
  headerIcon: {
    color: "#8084FF",
    fontSize: 18,
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: "#101828",
  },
  close: {
    fontSize: 14,
    width: 30,
    height: 30,
  },
  creditsBanner: {
    mt: 1.5,
    backgroundColor: "#f9fafb",
    borderRadius: 1,
    px: 1,
    py: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
  },
  creditsText: {
    fontSize: 14,
    color: "#364153",
    display: "flex",
    alignItems: "center",
    gap: 0.75,
  },
  creditsInfoIcon: {
    color: "info.main",
    cursor: "help",
    fontSize: 13,
    ml: 0.25,
  },
  buyMoreButton: {
    textTransform: "none",
    backgroundColor: "white",
    border: "1px solid rgba(0,0,0,0.1)",
    color: "#0a0a0a",
    fontSize: 12,
    fontWeight: 500,
    borderRadius: 1,
    px: 1.5,
    py: 0.25,
    minHeight: 28,
    "&:hover": { backgroundColor: "white" },
  },
  messages: {
    flex: 1,
    overflowY: "auto",
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
  },
  userBubble: {
    alignSelf: "flex-end",
    bgcolor: "rgba(128,132,255,0.18)",
    border: "1px solid rgba(128,132,255,0.35)",
    color: "#101828",
    px: 2,
    py: 1,
    borderRadius: 2,
    maxWidth: "80%",
    whiteSpace: "pre-wrap" as const,
  },
  assistantBubble: {
    alignSelf: "flex-start",
    bgcolor: "white",
    border: `1px solid ${grey[300]}`,
    px: 2,
    py: 1,
    borderRadius: 2,
    maxWidth: "90%",
  },
  assistantText: {
    whiteSpace: "pre-wrap" as const,
  },
  assistantLink: {
    color: "#8084FF",
    textDecoration: "underline",
    fontWeight: 500,
  },
  userLink: {
    color: "#3a3fc8",
    textDecoration: "underline",
    fontWeight: 500,
  },
  typingDots: {
    display: "inline-flex",
    gap: 0.4,
    alignItems: "center",
    height: 16,
    "& span": {
      width: 6,
      height: 6,
      borderRadius: "50%",
      bgcolor: grey[500],
      animation: "assistantTypingPulse 1.2s ease-in-out infinite",
    },
    "& span:nth-of-type(2)": { animationDelay: "0.2s" },
    "& span:nth-of-type(3)": { animationDelay: "0.4s" },
    "@keyframes assistantTypingPulse": {
      "0%, 80%, 100%": { opacity: 0.25 },
      "40%": { opacity: 1 },
    },
  },
  inlineTyping: {
    ml: 0.5,
    verticalAlign: "middle",
    display: "inline-flex",
  },
  input: {
    p: 2,
    borderTop: `1px solid ${grey[200]}`,
    display: "flex",
    gap: 1,
    alignItems: "stretch",
  },
  sendButton: {
    backgroundColor: "#8084FF",
    color: "white",
    borderRadius: 1,
    minWidth: 36,
    width: 36,
    alignSelf: "stretch",
    "&:hover": { backgroundColor: "#6970E8" },
    "&.Mui-disabled": {
      backgroundColor: "#8084FF",
      opacity: 0.5,
      color: "white",
    },
  },
  sendIcon: {
    fontSize: 14,
  },
  loadingStack: {
    display: "flex",
    flexDirection: "column",
    gap: 1.25,
    py: 1,
  },
  loadingBubbleAssistant: {
    bgcolor: "rgba(0,0,0,0.04)",
    borderRadius: 2,
    width: "78%",
  },
  loadingBubbleUser: {
    bgcolor: "rgba(128,132,255,0.18)",
    borderRadius: 2,
    width: "55%",
    alignSelf: "flex-end",
  },
};

export default styles;
